import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
});

// Request interceptor
api.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  response => response.data,
  error => {
    const message = error.response?.data?.error || error.message || 'An error occurred';
    return Promise.reject(new Error(message));
  }
);

// Articles
export const getArticles = (params = {}) => api.get('/articles', { params });
export const getFeaturedArticles = () => api.get('/articles/featured');
export const getTrendingArticles = () => api.get('/articles/trending');
export const getArticle = (slug) => api.get(`/articles/${encodeURIComponent(slug)}`);
export const likeArticle = (id) => api.post(`/articles/${id}/like`);

// Comments
export const getComments = (articleId) => api.get(`/articles/${articleId}/comments`);
export const postComment = (articleId, data) => api.post(`/articles/${articleId}/comments`, data);
export const likeComment = (commentId) => api.post(`/comments/${commentId}/like`);

// Menu
export const getMenu = () => api.get('/menu');

// Categories
export const getCategories = () => api.get('/categories');
export const getCategory = (slug) => api.get(`/categories/${encodeURIComponent(slug)}`);

// Newsletter
export const subscribeNewsletter = (data) => api.post('/newsletter/subscribe', data);

// Search
export const searchArticles = (q, limit = 10) => api.get('/search', { params: { q, limit } });

// Stats
export const getStats = () => api.get('/stats');

// Widgets (public)
export const getWidgets = (articleId) =>
  api.get('/widgets', { params: articleId ? { articleId } : {} });

// Widgets (admin)
export const getWidgetsAdmin = () => api.get('/widgets/admin');
export const createWidget    = (data)     => api.post('/widgets', data);
export const updateWidget    = (id, data) => api.put(`/widgets/${id}`, data);
export const deleteWidget    = (id)       => api.delete(`/widgets/${id}`);
export const reorderWidgets  = (order)    => api.post('/widgets/reorder', { order });

// Settings (public read / admin write)
export const getSettings    = ()     => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);

// Comments (admin)
export const getCommentsAdmin  = (articleId) =>
  api.get(`/articles/${articleId}/comments`);
export const deleteComment = (commentId) =>
  api.delete(`/articles/comments/${commentId}`);

export default api;
